import nirCheckDialog from './nirCheckDialog';

export default {
	nirCheckDialog
};
